import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import clsx from 'clsx'
import {Link} from 'react-router-dom'

interface FooterNavigationForServicePagesProps {
    className?: string
}

// Навигация по сервисным страницам сервиса.
export function FooterNavigationForServicePages(props: FooterNavigationForServicePagesProps) {

    const {
        className,
    } = props

    return (
        <nav
            className={clsx(
                'footer-links-bottom fs-7',
                className
            )}
        >
            <Link to={appUrl().support.buySellProcess}>
                {trans().common.footer.terms_of_service}
            </Link>
            <Link to={appUrl().support.privacyPolicy}>
                {trans().common.footer.privacy_policy}
            </Link>
            <Link to={appUrl().support.disputeResolution}>
                {trans().common.footer.dispute_resolution}
            </Link>
        </nav>
    )
}
